"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgTildeCircle(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M12 0C5.374 0 0 5.374 0 12c0 6.628 5.373 12 12 12 6.628 0 12-5.372 12-12 0-6.627-5.372-12-12-12zm0 1.532c5.782 0 10.468 4.687 10.468 10.468 0 5.782-4.686 10.468-10.468 10.468-5.78 0-10.468-4.686-10.468-10.468C1.532 6.22 6.22 1.532 12 1.532zM15.323 8l-3.325 4.485L8.67 8 6 11.99l3.185 4.3h5.638L18 12.004 15.323 8z",
    fill: "inherit",
    fillRule: "nonzero"
  }));
}

var _default = SvgTildeCircle;
exports.default = _default;